import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseSearchDto } from '../../../shared/modules/base/dtos/base-search.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { SupplierSearchDto } from '../../suppliers/dtos/supplier-search.dto';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { VehicleInsuranceCoverageTypeEnum } from '../enums/vehicle-insurance-coverage-type.enum';
import { VehicleInsurancePremiumPeriodEnum } from '../enums/vehicle-insurance-premium-period.enum';
import { VehicleInsuranceRecordCategoryEnum } from '../enums/vehicle-insurance-record-category.enum';
import { VehicleInsuranceStatusEnum } from '../enums/vehicle-insurance-status.enum';

import { VehicleInsuranceLinksDto } from './vehicle-insurance-links.dto';

/**
 * Vehicle insurance DTO for searchable fields
 */
@CaslSubject(AppSubjectEnum.VEHICLE_INSURANCE)
export class VehicleInsuranceSearchDto extends BaseSearchDto {
  code!: string;
  externalReference?: string | null;
  startsAt!: Date;
  endsAt!: Date;
  status!: VehicleInsuranceStatusEnum;
  recordCategory!: VehicleInsuranceRecordCategoryEnum;
  vehicleVin!: string;
  vehicleLicensePlate?: string | null;
  vehicleMakeFull?: string | null;
  supplierId?: number | null;
  supplier?: SupplierSearchDto | null;
  supplierName?: string | null;
  amount?: number | null;
  premiumPeriod?: VehicleInsurancePremiumPeriodEnum | null;
  coverageType?: VehicleInsuranceCoverageTypeEnum | null;
  links?: VehicleInsuranceLinksDto | null;
  files?: FileDto[] | null;
  tags?: TagListDto[] | null;
}
